import { CircleSpinner as Spinner } from '@im-frontend/components/Spinner';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { appStore } from '~/stores/AppStore';
import { settingsStore } from '~/stores/SettingsStore';

// Route that redirects to /login unless user is authenticated.
export const PrivateRoute = observer(
  ({
    children,
  }: React.PropsWithChildren<object>): React.ReactElement | null => {
    const location = useLocation();
    const isLoadingSetting = settingsStore.loading;
    return appStore.isLoggedIn ? (
      isLoadingSetting ? (
        <Spinner />
      ) : (
        <>{children}</>
      )
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location },
        }}
      />
    );
  }
);
